namespace $.$$ {

	export class $shm_ba_dashboard_indicators extends $.$shm_ba_dashboard_indicators {

		options() {
			return [
				'Сообщения',
				'Авторы',
				'Источники',
				'Аудитория',
				'Просмотры',
				'Комментарии',
				'Вовлеченность',
				'Лайки',
				'Репосты',
				'Аудитория СМИ',
				'Цитируемость СМИ',
			]
		}

		user_id() {
			return this.$.$shm_ba_pb.user_id()
		}

		settings_trigger() {
			return `dashboard_indicator_settings/user:${ this.user_id() }:dashboard:${ this.dashboard_id() }`
		}

		settings_key() {
			return `${ this.user_id() }\n${ this.dashboard_id() }`
		}

		settings_records() {
			const user = this.user_id()
			const dashboard = this.dashboard_id()
			if( !user || !dashboard || dashboard === 'default' ) return [] as readonly $shm_ba_pb_file_record[]

			return this.$.$shm_ba_pb.records_page_realtime_live(
				`dashboard_indicator_settings\nuser = "${ this.$.$shm_ba_pb.filter_text( user ) }" && dashboard = "${ this.$.$shm_ba_pb.filter_text( dashboard ) }"\n\n1\n1\nid,user,dashboard,indicators,indicator_order`,
				this.settings_trigger(),
				record => String( record.user || '' ) === user && String( record.dashboard || '' ) === dashboard,
			)
		}

		settings_record() {
			return this.settings_records()[0] ?? null
		}

		@ $mol_mem_key
		selected_draft( settings: string, next?: readonly string[] | null ) {
			return next ?? null
		}

		selected( next?: readonly string[] ) {
			if( next !== undefined ) {
				const selected = this.indicator_order().filter( option => next.includes( option ) )
				this.selected_draft( this.settings_key(), selected )
				this.settings_save( selected, this.indicator_order() )
				return selected
			}

			const draft = this.selected_draft( this.settings_key() )
			if( draft ) return draft

			const stored = this.settings_record()?.indicators
			if( !Array.isArray( stored ) ) return this.options()
			return this.indicator_order().filter( option => stored.includes( option ) )
		}

		@ $mol_action
		settings_save( indicators: readonly string[], indicator_order: readonly string[] ) {
			const user = this.user_id()
			const dashboard = this.dashboard_id()
			if( !user || !dashboard || dashboard === 'default' ) return indicators

			const record = this.settings_record()
			if( record ) {
				this.$.$shm_ba_pb.update_record( 'dashboard_indicator_settings', record.id, { indicators, indicator_order })
			} else {
				this.$.$shm_ba_pb.create_record( 'dashboard_indicator_settings', { user, dashboard, indicators, indicator_order })
			}
			this.$.$shm_ba_pb.realtime_live_reload( this.settings_trigger() )
			this.selected_draft( this.settings_key(), null )
			this.indicator_order_draft( this.settings_key(), null )
			return indicators
		}

		indicator_rows() {
			return this.indicator_order().map( option => this.Indicator_row( option ) )
		}

		@ $mol_mem_key
		indicator_order_draft( settings: string, next?: readonly string[] | null ) {
			return next ?? null
		}

		indicator_order( next?: readonly string[] ) {
			if( next !== undefined ) {
				const order = this.order_sanitized( next )
				this.indicator_order_draft( this.settings_key(), order )
				this.settings_save( this.selected(), order )
				return order
			}

			const draft = this.indicator_order_draft( this.settings_key() )
			if( draft ) return draft

			const stored = this.settings_record()?.indicator_order
			return this.order_sanitized( Array.isArray( stored ) ? stored : [] )
		}

		order_sanitized( order: readonly unknown[] ) {
			const options = this.options()
			return [
				... order.filter( ( option ): option is string => typeof option === 'string' && options.includes( option ) ),
				... options.filter( option => !order.includes( option ) ),
			].filter( ( option, index, all )=> all.indexOf( option ) === index )
		}

		all_checked( next?: boolean ) {
			if( next === undefined ) return this.selected().length === this.options().length
			this.selected( next ? this.indicator_order() : [] )
			return next
		}

		indicator_transfer( option: string ) {
			return `shm-ba-dashboard-indicator:${ option }`
		}

		indicator_adopt( transfer?: DataTransfer ) {
			if( !transfer ) return null
			const prefix = 'shm-ba-dashboard-indicator:'
			const value = transfer.getData( 'text/plain' )
			if( !value.startsWith( prefix ) ) return null
			const option = value.slice( prefix.length )
			return this.options().includes( option ) ? option : null
		}

		@ $mol_action
		indicator_receive_before( anchor: string, option?: string | null ) {
			if( !option || anchor === option ) return option
			const current = this.indicator_order()
			const moving_down = current.indexOf( option ) < current.indexOf( anchor )
			const order = current.filter( current => current !== option )
			const anchor_index = order.indexOf( anchor )
			order.splice( anchor_index + Number( moving_down ), 0, option )
			this.indicator_order( order )
			return option
		}

		@ $mol_action
		indicator_receive_end( option?: string | null ) {
			if( !option ) return option
			this.indicator_order([ ... this.indicator_order().filter( current => current !== option ), option ])
			return option
		}

		indicator_title( option: string ) {
			return option
		}

		indicator_checked( option: string, next?: boolean ) {
			const selected = this.selected()
			if( next === undefined ) return selected.includes( option )

			this.selected( next
				? [ ... selected, option ]
				: selected.filter( current => current !== option ),
			)
			return next
		}

	}

}
